function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Menu, useMenuState, MenuTrigger } from "@sprout/list-navigation/dist/Menu";
import { MoreHoriz } from "sprout-ui-icons";
import { PageToolbarItem } from "@sprout/client-components/dist/PageToolbar";
const PostPageToolbarMenuPopover = (props)=>{
    const { children  } = props;
    const menuState = useMenuState();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(MenuTrigger, _objectSpread({}, menuState, {
                children: /*#__PURE__*/ _jsx(PageToolbarItem, {
                    icon: MoreHoriz,
                    label: "More"
                })
            })),
            /*#__PURE__*/ _jsx(Menu, _objectSpread({}, menuState, {
                $size: "lg",
                placement: "top",
                children: children
            }))
        ]
    });
};
export default PostPageToolbarMenuPopover;
